const e = {
  undo: "Ongedaan maken",
  redo: "Opnieuw",
  confirm: "Bevestigen",
  clear: "Wissen",
  more: "meer",
  cancel: "Annuleren",
  update: "Bijwerken"
}, n = {
  positiveText: "Bevestigen",
  negativeText: "Annuleren"
}, t = {
  placeholder: "Maak een keuze",
  loading: "Aan het laden"
}, a = {
  clear: "Wissen",
  now: "Nu",
  confirm: "Bevestigen",
  selectTime: "Tijd selecteren",
  selectDate: "Datum selecteren",
  datePlaceholder: "Datum selecteren",
  datetimePlaceholder: "Selecteer datum en tijd",
  monthPlaceholder: "Selecteer Maand",
  yearPlaceholder: "Selecteer Jaar",
  quarterPlaceholder: "Selecteer kwartaal",
  startDatePlaceholder: "Begindatum",
  endDatePlaceholder: "Einddatum",
  startDatetimePlaceholder: "Begindatum en tijd",
  endDatetimePlaceholder: "Einddatum en tijd",
  startMonthPlaceholder: "Start maand",
  endMonthPlaceholder: "Eind maand",
  today: "Vandaag"
}, r = {
  checkTableAll: "Selecteer alles in de tabel",
  uncheckTableAll: "Deselecteer alles in de tabel",
  confirm: "Bevestigen",
  clear: "Wissen",
  apply: "Toepassen",
  filters: "Filteren",
  sort: "Sorteren"
}, o = {
  sourceTitle: "Bron",
  targetTitle: "Doel"
}, l = {
  selectAll: "Alles selecteren",
  unselectAll: "Alles deselecteren",
  clearAll: "Wissen"
}, i = {
  description: "Geen gegevens"
}, c = {
  placeholder: "Maak een keuze"
}, s = {
  placeholder: "Tijd selecteren",
  positiveText: "Oké",
  negativeText: "Annuleren",
  now: "Nu"
}, d = {
  goto: "Goto",
  selectionSuffix: "pagina",
  next: "Volgende",
  previous: "Vorige"
}, g = {
  add: "Toevoegen"
}, m = {
  loading: "Aan het laden"
}, u = {
  placeholder: "Invoeren"
}, p = {
  placeholder: "Invoeren"
}, k = {
  create: "Aanmaken"
}, h = {
  title: "Thema-editor",
  clearAllVars: "Alle variabelen wissen",
  clearSearch: "Zoekopdracht wissen",
  filterCompName: "Naam filtercomponent",
  filterVarName: "Naam filtervariabele",
  import: "Importeren",
  export: "Exporteren",
  restore: "Terugzetten naar standaard"
}, T = {
  tipPrevious: "Vorige afbeelding (←)",
  tipNext: "Volgende afbeelding (→)",
  tipCounterclockwise: "Linksom",
  tipClockwise: "Met de klok mee",
  tipZoomOut: "Uitzoomen",
  tipZoomIn: "Inzoomen",
  tipClose: "Afsluiten (Esc)",
  tipOriginalSize: "Zoom naar origineel formaat"
}, v = {
  heading: "Sorteren en filteren",
  sortHeading: "Sorteren op",
  newestFirst: "Nieuwste eerst",
  oldestFirst: "Oudste eerst",
  ascending: "Asc",
  descending: "Beschrijving",
  apply: "Toepassen",
  clear: "Wissen",
  cancel: "Annuleren",
  filters: "Filteren"
}, f = {
  noMatchingFound: "Geen overeenkomende resultaten gevonden"
}, P = {
  margin: "Marge",
  padding: "Opvulling",
  reset: "Herstellen",
  errorMsg: "De opgegeven waarde is ongeldig."
}, S = {
  brandColors: "Merkkleuren",
  noBrandColors: "U heeft nog geen merkkleuren toegevoegd.",
  getStarted: "Aan de slag",
  add: "Toevoegen",
  default: "Standaard"
}, A = {
  addColor: "Nieuwe kleur toevoegen",
  editColor: "Kleur bewerken",
  add: "Toevoegen",
  noData: "U hebt nog geen kleuren toegevoegd.",
  invalidCode: "Ongeldige kleurcode",
  defaultColor: "Standaardkleuren"
}, D = {
  global: e,
  Popconfirm: n,
  Cascader: t,
  DatePicker: a,
  DataTable: r,
  LegacyTransfer: o,
  Transfer: l,
  Empty: i,
  Select: c,
  TimePicker: s,
  Pagination: d,
  DynamicTags: g,
  Log: m,
  Input: u,
  InputNumber: p,
  DynamicInput: k,
  ThemeEditor: h,
  Image: T,
  SortFilter: v,
  IconPicker: f,
  Spacing: P,
  BrandColorPicker: S,
  BrandBoard: A
};
export {
  A as BrandBoard,
  S as BrandColorPicker,
  t as Cascader,
  r as DataTable,
  a as DatePicker,
  k as DynamicInput,
  g as DynamicTags,
  i as Empty,
  f as IconPicker,
  T as Image,
  u as Input,
  p as InputNumber,
  o as LegacyTransfer,
  m as Log,
  d as Pagination,
  n as Popconfirm,
  c as Select,
  v as SortFilter,
  P as Spacing,
  h as ThemeEditor,
  s as TimePicker,
  l as Transfer,
  D as default,
  e as global
};
